"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = HolidaySavingsHistory;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const Helper_1 = require("../Helper");
const HolidaySavings_1 = __importDefault(require("../api/HolidaySavings"));
const UserContext_1 = require("../contexts/UserContext");
const Screen_1 = __importDefault(require("../components/Screen"));
const Card_1 = __importDefault(require("../components/Card"));
const Loading_1 = __importDefault(require("../components/Loading"));
const List_1 = __importDefault(require("../components/List"));
const Button_1 = __importDefault(require("../components/Button"));
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        flex: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
        },
        separator: {
            backgroundColor: THEME.Black + '1A',
            height: 1,
            marginHorizontal: -12,
            marginVertical: 2
        },
        text: {
            color: THEME.Text,
            fontSize: 14,
            textAlign: 'center'
        }
    });
};
function HolidaySavingsHistory(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [history, setHistory] = react_1.default.useState(null);
    const [year, setYear] = react_1.default.useState(((new Date()).getMonth() == 10 || (new Date()).getMonth() == 11) ? (new Date()).getFullYear() + 1 : (new Date()).getFullYear());
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        refresh().then(() => setRefreshing(false));
        return () => promise.current?.cancel();
    }, []);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        setHistory(null);
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => HolidaySavings_1.default.getHistory(token, year.toString()))).then((data) => {
            let transform = (t) => (i) => ({ type: t, date: i.payDate, amount: i.amount });
            let history = [
                ...data.contributions.map(transform('Contribution')),
                ...data.distributions.map(transform('Distribution'))
            ];
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => HolidaySavings_1.default.getPayoutRequests(token))).then((payoutData) => {
                var pendingPayouts = payoutData.filter(r => !r.processed && new Date(r.requestDate).getFullYear() == year).map(r => {
                    return { type: 'PendingDistribution', date: r.requestDate, amount: Number(r.balance) };
                });
                history = [
                    ...history,
                    ...pendingPayouts
                ];
            }).finally(() => {
                history.sort((a, b) => (new Date(b.date).getTime() - new Date(a.date).getTime()));
                setHistory(history);
                setStatus('done');
            });
        }).catch(() => {
            setHistory(null);
            setStatus('error');
        });
    }, [year]);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [refresh]);
    return ((0, jsx_runtime_1.jsx)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, children: (0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 6, marginBottom: 12, flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('myPay:hints.prevYear'), color: THEME.Secondary, onPress: () => setYear(year - 1), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 18, icon: Theme_1.ICONS.Solid.ChevronLeft, style: { color: THEME.AlwaysWhite, marginTop: 2 } }) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: [styles.text, { fontSize: 16, fontWeight: '500', marginTop: -2 }], children: ["Nov 1, ", year - 1, " \u2014 Oct 31, ", year] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('myPay:hints.nextYear'), color: THEME.Secondary, disabled: ((new Date()).getMonth() == 10 || (new Date()).getMonth() == 11) ? year >= (new Date()).getFullYear() + 1 : year >= (new Date()).getFullYear(), onPress: () => setYear(year + 1), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 18, icon: Theme_1.ICONS.Solid.ChevronRight, style: { color: THEME.AlwaysWhite, flex: 1, marginTop: 2 } }) }) })] }), (0, jsx_runtime_1.jsx)(TableHeader_1.default, { columns: [
                        { flex: 1, label: t('myPay:text.date') },
                        { flex: 1, label: t('common:text.type') },
                        { flex: 1, label: t('myPay:text.amt') },
                    ] }), (0, jsx_runtime_1.jsx)(List_1.default, { data: history, keyExtractor: (item, index) => year + '-' + index.toString(), itemSeparator: () => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.separator })), renderItem: (item) => ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(HistoryItem, { date: item.date, type: t('myPay:text.' + item.type), amount: item.amount, rowType: item.type }) })), listEmpty: () => (status == 'done')
                        &&
                            (0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { margin: 8, marginTop: 16 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.PiggyBank, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: size != 'sm' ? 16 : 14, color: THEME.TextNull, textAlign: 'center' }, children: t('myPay:text.noHist') })] }) })
                        ||
                            (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) })] }) }));
}
;
const HistoryItem = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const date = props.date ? new Date(props.date).toLocaleDateString(Helper_1.Helper.deviceLanguage(), { month: 'short', year: "numeric", day: 'numeric', timeZone: 'UTC' }) : "—";
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.flex, { paddingVertical: 12, backgroundColor: props.rowType == "Distribution" ? THEME.SecondaryLightest + 'AA' : props.rowType == "PendingDistribution" ? THEME.WarningLightest : 'transparent' }], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: date }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: props.type }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.text, { fontSize: 16, fontWeight: '500' }], children: Helper_1.Helper.FormatCurrency(props.amount) }) })] }));
};
